/**
 * 资金管理
 */
 export default [
    {
      path: '/moneyMonitor/rewardFundManagement',
      component: resolve => require(['../../views/moneyMonitor/rewardFundManagement'], resolve),
      meta: { title: '奖励基金管理中心' }
    },
    {
      path: '/moneyMonitor/rewardMonitoring',
      component: resolve => require(['../../views/moneyMonitor/rewardMonitoring'], resolve),
      meta: { title: '奖励基金监控中心' }
    },


    {
      path: '/andPackage/index',
      component: resolve => require(['../../views/andPackage/index'], resolve),
      meta: { title: '和包账号' }
    },
    {
      path: '/andPackage/detailList',
      component: resolve => require(['../../views/andPackage/theDetail/theDetail'], resolve),
      meta: { title: '收支明细' }
    },
    {
      path: '/moneyMonitor/cashBackList',
      component: resolve => require(['../../views/moneyMonitor/cashBackList'], resolve),
      meta: { title: '返现列表' }
    },
    {
      path: '/moneyMonitor/downPaymentList',
      component: resolve => require(['../../views/moneyMonitor/downPaymentList'], resolve),
      meta: { title: '直客收付款信息列表' }
    },
    


  ]
  


// WEBPACK FOOTER //
// ./src/SRM/router/modules/money.js